import React from 'react';
import { ScreenProps } from '@fnol/library/src/lib';
import { translations } from '../../lib/consts';
import { Button } from '@fnol/library/src/components';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { common } from '@fnol/library/src/lib/consts';

export const FirstMessage = ({ navigator }: ScreenProps) => {
    const [currentStep, { goForward }] = navigator;
    return (
        <>
            <Box sx={{ width: '100%', height: 400, paddingTop: '15px' }}>
                <Typography>
                    <h2>{translations.intro.INTRO_MESSAGE_1_TITLE}</h2>
                    <ul style={{ fontSize: '1.1rem' }}>
                        {/* <li>{translations.intro.INTRO_MESSAGE_1_LINE_1}</li> */}
                        <li>{translations.intro.INTRO_MESSAGE_1_LINE_2}</li>
                        <li>{translations.intro.INTRO_MESSAGE_1_LINE_3}</li>
                        <li>{translations.intro.INTRO_MESSAGE_1_LINE_4}</li>
                        <li>{translations.intro.INTRO_MESSAGE_1_LINE_5}</li>
                        <li>
                            {translations.intro.INTRO_MESSAGE_1_LINE_6_1}
                            <a href={translations.intro.INTRO_MESSAGE_1_LINE_6_LINK_1} target="_blank" rel="noreferrer">
                                {translations.intro.INTRO_MESSAGE_1_LINE_6_2}
                            </a>
                            {translations.intro.INTRO_MESSAGE_1_LINE_6_3}
                            <a href={translations.intro.INTRO_MESSAGE_1_LINE_6_LINK_2} target="_blank" rel="noreferrer">
                                {translations.intro.INTRO_MESSAGE_1_LINE_6_4}
                            </a>
                        </li>
                    </ul>
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingTop: '15px' }}>
                <div></div>
                <Button onClickHandler={goForward} label={common.NEXT} />
            </Box>
        </>
    );
};
